import { Box } from "@mui/material";
import styled from "styled-components";

const Page = styled(Box)`
  background-color: '#E3E5E8';
`;

const GradientOverlay = styled(Box)`
  background: radial-gradient(circle, 
    #FFF2E7 0%, 
    #F9F8F8 34%, 
    #FFFFFF 71%, 
    #E6ECF8 100%
  );

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
`;

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  max-width: 25rem;
  align-items: center;
  height: calc(100vh - 64px);
  text-align: center;
`;

type ScenariosSubLayoutProps = {
  children: React.ReactNode;
};

export const ScenariosSubLayout = ({
  children
}: ScenariosSubLayoutProps) => {
  return (
    <Page>
      <GradientOverlay>
        <Container>
          {children}
        </Container>
      </GradientOverlay>
    </Page>
  );
}
